import React, { useState } from 'react';
import { DocumentArrowDownIcon } from '@heroicons/react/24/outline';
import { generateDocx } from '../../services/docx-generator';
import { AgentButton } from './AgentPageLayout';

interface AgentOutputActionsProps {
  content: string;
  agentName: string;
  agentCode: string;
  reference?: string;
}

const AgentOutputActions: React.FC<AgentOutputActionsProps> = ({
  content,
  agentName,
  agentCode,
  reference = ''
}) => {
  const [isGeneratingDocx, setIsGeneratingDocx] = useState(false);
  const [docxError, setDocxError] = useState<string | null>(null);

  const handleSaveToWord = async () => {
    setIsGeneratingDocx(true);
    setDocxError(null);
    
    try {
      const fileName = reference 
        ? `${agentName.toLowerCase().replace(/\s+/g, '-')}-${reference.replace(/[^a-zA-Z0-9]/g, '-')}.docx`
        : `${agentName.toLowerCase().replace(/\s+/g, '-')}-${new Date().toISOString().split('T')[0]}.docx`;
      
      const title = reference 
        ? `${agentName} - ${reference}`
        : agentName;
      
      await generateDocx(content, fileName, title);
    } catch (error) {
      const message = error instanceof Error ? error.message : "Ocorreu um erro desconhecido ao gerar o arquivo DOCX.";
      setDocxError(message);
      console.error("DOCX Generation Error:", error);
    } finally {
      setIsGeneratingDocx(false);
    }
  };

  return (
    <div className="flex items-center gap-3 flex-wrap">
      <AgentButton
        type="button"
        onClick={handleSaveToWord}
        disabled={isGeneratingDocx}
        variant="secondary"
        className="inline-flex items-center gap-1.5"
      >
        <DocumentArrowDownIcon className="w-5 h-5" aria-hidden="true" />
        <span>{isGeneratingDocx ? 'Gerando...' : 'Salvar em Word'}</span>
      </AgentButton>
      {docxError && (
        <span className="text-sm text-destructive bg-destructive/10 px-3 py-1.5 rounded-md">
          {docxError}
        </span>
      )}
    </div>
  );
};

export default AgentOutputActions;

